import React from 'react'
import Chevron from '../../../components/Chevron'
import { Direction } from '../../../utils/constants'
import { twMerge } from 'tailwind-merge'

interface TestimonialNavigationProps {
  count: number
  currentTestimonial: number
  setCurrentTestimonial: (value: number) => void
}

const TestimonialNavigation = ({
    count,
    currentTestimonial,
    setCurrentTestimonial,
}: TestimonialNavigationProps) => {
    const getArrowStyles = (isDisabled: boolean) => {
        const disabled = isDisabled ? 'stroke-black/20' : 'stroke-white bg-purple'
        return twMerge('p-2 rounded-full', disabled)
    }

    if (count <= 1) {
        return null
    }

    return (
        <div className='flex items-center gap-x-3 pt-10'>
            <button
                onClick={() => setCurrentTestimonial(currentTestimonial - 1)}
                disabled={currentTestimonial === 0}
                className={getArrowStyles(currentTestimonial === 0)}
            >
                <Chevron direction={Direction.LEFT} className={twMerge('w-4 ml-0 stroke-inherit')} />
            </button>
            <h6 className='testimonial-name opacity-100'>
                {currentTestimonial + 1} / {count}
            </h6>
            <button
                onClick={() => setCurrentTestimonial(currentTestimonial + 1)}
                disabled={currentTestimonial + 1 === count}
                className={getArrowStyles(currentTestimonial + 1 === count)}
            >
                <Chevron direction={Direction.RIGHT} className='w-4 ml-0 stroke-inherit' />
            </button>
        </div>
    )
}

export default TestimonialNavigation
